import React, { Component } from "react";
import * as StyledGlobalCSS from "../../constants/common/StyledGlobalConstants";
import * as Actions from "../../store/actions/global/global";
import * as billingActions from "../../store/actions/billing/billing";
import { withRouter } from "../../withRouter";
import { connect } from "react-redux";
import Cookies from "js-cookie";
import ManageHeader from "../../components/header/ManageHeader";
import EnglishCASample from "../../assets/images/English_CA_Sample.png";
import FrenchCASample from "../../assets/images/French_CA_Sample.png";
import GermanCASample from "../../assets/images/German_CA_Sample.png";
import DutchCASample from "../../assets/images/Dutch_CA_Sample.png";
import PlannedMaintenance from "./PlannedMaintenance";
import { withTranslation } from "react-i18next";
import { changeLanguage } from "../../util/userLanguageUtils";
import { findRoutingPath } from "../../util/helpURLNavigation";
import { pendoTrack } from "../../util/pendoUtil";
import SeamlessAcess from "./seamlessAcess";
import { Loader } from "@vds/loaders";
import RedesignedModal from "../../components/common/RedesignedModal";
import { isNonERPCountryAccount } from "../../util/nonERPCountryUtils";
import { getDefaultLandingPermission } from "../../util/permissionUtils";
import PropTypes from "prop-types";
import { suspendedFinancialStatuses, terminatedFinancialStatuses, REDBALL_FEATURE_TOGGLE } from "../../constants/appConstants";
import { getRegion } from "../../util/util";

const breakPoint = 480;

const validFinancialStatuses = ["Active", "Reactivated"];
class SecondLayerAuth extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorText: "Please enter a valid Account Number",
      validationMessage: "",
      validationErrorMessage: "",
      notificationErrStatus: false,
      inputBoxStyle: this.normalStyle,
      showMessage: false,
      errorState: false,
      error: false,
      sucess: false,
      count: 0,
      countLeft: 3,
      contractNumber: "",
      openOrClose: false,
      loader: false,
      submitDisabled: true,
      inputDiasabled: false,
      connectionError: false,
      timeLeft: 20,
      userLanguage: "",
      nameSpace: "",
      middlePage: false,
    };
  }

  componentDidMount() {
    Cookies.remove("customerPortalSessionExpired");
    const language = this.props.userLanguage.replace(/-/g, "");
    const nameSpace = changeLanguage(language, "login");
    this.props.i18n.changeLanguage(language);
    if (this.props.title) {
      const translatedTitle = this.props.t(this.props.title, { ns: nameSpace });
      document.title = translatedTitle;
    }
    this.setState({
      userLanguage: language,
      nameSpace: nameSpace,
    });

    const loginCallBack = (msg, accId = "", response = null) => {
      if (msg) {
        this.props.setRevealSessionExpired(true);
      } else {
        sessionStorage.setItem("applicationLoaded", true);
        this.props.setActiveCookie(true);
        document.title = this.props.t(`${this.props.title}`, {
          ns: `${this.state.nameSpace}`,
        });
        if (accId) {
          const userType = response?.data?.data?.userType || null;
          const responseDataRegionId = response?.data?.data?.regionId || null;
          this.getPermissionAndContractAccounts(userType, responseDataRegionId, response?.data?.data);
        }
      }
    };
    if (!this.props.timersRunning) {
      this.props.setTimersRunning(true);
    }
    if (sessionStorage.getItem("applicationLoaded") === null) {
      this.props.getAccountAndUser(loginCallBack);
    } else if (sessionStorage.getItem("applicationLoaded") && this.props.enableSecondPage) {
      this.props.setSecondPage(true, false);
      this.getPermissionAndContractAccounts(this.props.userType, this.props.regionId);
    }
  }
  getPermissionAndContractAccounts = (userType = null, regionId = null, loginResponseData = {}) => {
    //If userType is 2 or 4, that is treated as admin user. Then revealPermissionCall will not happen.
    if (userType !== "2" && userType !== "4") {
      this.props.getPermission(this.getContractNumbers, loginResponseData);
    } else {
      this.getContractNumbers(userType, {}, regionId, false);
    }
  };

  hideError = () => {
    this.setState({
      errorState: false,
      error: false,
      notificationErrStatus: false,
    });
  };

  helpFindCAN = () => {
    this.setState((prevState) => ({ showHelpModal: !prevState.showHelpModal }));
  };

  checkContractAccountDetails = () => {
    return this.props.erpBusinessPartner?.data?.contractAccountDetails;
  };

  hasValidContractAccounts = () => {
    const accountFinancialStatus = this.props.erpBusinessPartner.data?.accountFinancialStatus;
    const filterByFinancialStatus = (item) => {
      if (!REDBALL_FEATURE_TOGGLE) {
        return validFinancialStatuses.includes(item.financialStatus);
      }

      if (validFinancialStatuses.includes(accountFinancialStatus)) {
        return validFinancialStatuses.includes(item.financialStatus);
      }

      return item.financialStatus;
    };

    return this.props.erpBusinessPartner.data.contractAccountDetails.filter(filterByFinancialStatus).length > 1;
  };

  getContractNumbers = (userType, permissions, regionId, isUserPermissionCallbackCalled = false) => {
    const blankPageTimer = null;

    //Sonar changes starts
    const contractNumbersCallBack = (status, response) => {
      if (status === "Error") {
        handleErrorResponse(response);
      } else {
        handleSuccessResponse(response);
      }
    };

    const handleErrorResponse = (response) => {
      pendoTrack("Customer Portal | Seamless Access | Contract Accounts", {
        status: "failed",
        statusCode: response?.response?.status,
        accountId: this.props.accountNumber,
      });
      this.props.navigate("/failedToAccessAccount");
      if (response.response.status !== 404) {
        this.setState({ connectionError: true });
      }
    };

    const handleSuccessResponse = (response) => {
      pendoTrack("Customer Portal | Seamless Access | Contract Accounts", {
        status: "Success",
        statusCode: response.data.statusCode,
        accountId: this.props.accountNumber,
      });

      if (this.props.bannerDisplayOnLanding) {
        this.props.setBannerDisplayOnAll(true);
      }

      const accountFinancialStatus = response?.data?.data?.accountFinancialStatus;
      this.props.getContractNumbersSuccess({
        accountFinancialStatus,
      });
      const isNonERPCountryAcc = checkIfNonERPCountry(response);

      handleFinancialStatusNavigation(accountFinancialStatus, isNonERPCountryAcc, response);
      handlePaymentStatus(accountFinancialStatus, response);
    };

    const checkIfNonERPCountry = (response) => {
      const country = response?.data?.data?.contractAccountDetails?.[0]?.country;
      return country ? isNonERPCountryAccount(country) : false;
    };

    const filterContractAccountDetails = (response, accountFinancialStatus) => {
      response.data.data.contractAccountDetails = response.data.data.contractAccountDetails.filter((item) =>
        validFinancialStatuses.includes(accountFinancialStatus)
          ? validFinancialStatuses.includes(item.financialStatus) && item.erpCANumber
          : item.financialStatus && item.erpCANumber
      );
    };

    const handleFinancialStatusNavigation = (accountFinancialStatus, isNonERPCountryAcc, response) => {
      if (
        REDBALL_FEATURE_TOGGLE &&
        !isNonERPCountryAcc &&
        terminatedFinancialStatuses.includes(accountFinancialStatus?.toLowerCase())
      ) {
        this.props.navigate("/inactiveAccount");
      } else if (
        REDBALL_FEATURE_TOGGLE &&
        !isNonERPCountryAcc &&
        suspendedFinancialStatuses.includes(accountFinancialStatus?.toLowerCase()) &&
        userType !== "2" &&
        userType !== "4"
      ) {
        this.props.navigate("/inactiveAccount");
      } else {
        if (REDBALL_FEATURE_TOGGLE) {
          filterContractAccountDetails(response, accountFinancialStatus);
        } else {
          response.data.data.contractAccountDetails = response.data.data.contractAccountDetails.filter(
            (item) => validFinancialStatuses.includes(item.financialStatus) && item.erpCANumber
          );
        }
        handleContractAccountDetails(response, isNonERPCountryAcc);
      }
    };

    const handleContractAccountDetails = (response, isNonERPCountryAcc) => {
      const contractAccountDetails = response?.data?.data?.contractAccountDetails;

      if (contractAccountDetails?.length > 1 && !isNonERPCountryAcc) {
        this.props.setContractAccountCountry(contractAccountDetails[0]?.country);
        this.props.getContractNumbersSuccess({
          accountID: "",
          businessPartnerNumber: "",
          vztSegment: response.data.data.vztSegment,
          brands: response.data.data.brands || "",
          accountFinancialStatus: response.data.data.accountFinancialStatus,
          data: response.data,
        });
      } else if ((contractAccountDetails?.length > 1 && isNonERPCountryAcc) || contractAccountDetails?.length === 1) {
        handleSingleOrMultipleAccounts(response, isNonERPCountryAcc);
      } else {
        this.props.navigate("/inactiveAccount");
      }
    };

    const handleSingleOrMultipleAccounts = (response, isNonERPCountryAcc) => {
      const contractAccountDetails = response?.data?.data?.contractAccountDetails;
      this.props.setContractAccount(contractAccountDetails[0].erpCANumber);
      this.props.getContractNumbersSuccess({
        accountID: response.data.data.accountId,
        businessPartnerNumber: response.data.data.businessPartnerNumber,
        accountFinancialStatus: response.data.data.accountFinancialStatus,
        vztSegment: response.data.data.vztSegment,
        brands: response.data.data.brands || "",
        data: response.data,
      });
      this.props.setContractAccountCountry(contractAccountDetails[0]?.country);

      let permissionName = "";
      if (isUserPermissionCallbackCalled) {
        permissionName = getPermissionName(permissions, isNonERPCountryAcc);
      } else {
        permissionName = findRoutingPath(
          Cookies.get("currentRoute"),
          isNonERPCountryAcc
          // , regionId
        );
      }
      this.landOnAuthorizedPage(permissionName);
    };

    const getPermissionName = (permissions, isNonERPCountryAcc) => {
      if (permissions && Object.keys(permissions).length) {
        permissions.viewtechnicianAppointmentsPermission = "Full";
        return getDefaultLandingPermission(permissions, isNonERPCountryAcc);
      }
      return "";
    };

    const handlePaymentStatus = (accountFinancialStatus, response) => {
      const regionFromLogin = getRegion();
      if (
        REDBALL_FEATURE_TOGGLE &&
        suspendedFinancialStatuses?.includes(accountFinancialStatus?.toLowerCase()) &&
        (regionFromLogin.isNA || regionFromLogin.isAPAC || regionFromLogin.isEMEA) &&
        response?.data?.data?.contractAccountDetails?.length > 0
      ) {
        this.getPaymentStatus(response?.data?.data?.contractAccountDetails);
      }
    };
    //Sonar changes ends
    this.props.getContractNumbers(this.props.accountNumber, this.props.userId, contractNumbersCallBack, blankPageTimer);
  };

  getPaymentStatus = (contractAccountDetails) => {
    // Frame the payload
    const paymentStatusPayload = {
      contractAccountId: contractAccountDetails.map((item) => item.contractAccountId),
    };

    const paymentStatusCallBack = (status, response) => {
      const contractAccountIds = contractAccountDetails.map((item) => item.contractAccountId).join(", ");
      const paymentData = response?.data?.data;

      // Handle error scenario
      if (status === "Error") {
        pendoTrack("Customer Portal | Billing And Payment | checkPaymentStatus", {
          status: "failed",
          statusCode: response?.response?.status,
          contractAccountId: contractAccountIds,
        });

        this.props.navigate("/failedToAccessAccount");

        if (response?.response?.status !== 404) {
          this.setState({ connectionError: true });
        }
        return;
      }

      // Handle success scenario with empty data
      if (!paymentData || paymentData.length === 0) {
        pendoTrack("Customer Portal | Billing And Payment | checkPaymentStatus", {
          status: "No Data",
          statusCode: response?.data?.statusCode,
          contractAccountId: contractAccountIds,
        });

        this.props.navigate("/failedToAccessAccount");
        return;
      }
      // Handle success scenario with data
      if (response?.data?.statusCode === "200") {
        for (const paymentDetails of paymentData) {
          if (paymentDetails.paymentStatus === "true") {
            pendoTrack("Customer Portal | Billing And Payment | checkPaymentStatus | True", {
              status: "Success",
              statusCode: response?.data?.statusCode,
              contractAccountId: paymentDetails.contractAccountId,
            });
          } else {
            pendoTrack("Customer Portal | Billing And Payment | checkPaymentStatus | False", {
              status: "Success",
              statusCode: response?.data?.statusCode,
              contractAccountId: paymentDetails.contractAccountId,
            });
          }
        }
      }
      try {
        this.props.getPaymentStatusSuccess({
          paymentStatus: paymentData?.paymentStatus,
          data: response?.data,
        });
      } catch (error) {
        pendoTrack("Customer Portal | Billing And Payment | Failed To Load checkPaymentStatus", {
          status: "Error in checkPaymentStatus",
          statusCode: error?.response?.data?.statusCode,
          contractAccountId: contractAccountIds,
        });
      }
    };

    // Call the getPaymentStatus API with the payload
    this.props.getPaymentStatus(paymentStatusPayload, paymentStatusCallBack);
  };

  landOnAuthorizedPage = (permissionName) => {
    if (Cookies.get("customerPortalSessionExpired")) {
      Cookies.remove("customerPortalSessionExpired");
      return;
    }

    const route = this.getRouteForPermission(permissionName);
    this.props.navigate(route);
  };

  getRouteForPermission = (permissionName) => {
    const routes = {
      viewInvoicesPermission: "/account/billing/invoice",
      managePaymentsPermission: "/account/billing/invoice",
      billingAndPayments: "/account/billing/invoice",
      makePayment: "/account/billing/invoice/makepayment",
      managePayment: "/account/billing/invoice/managepayment",
      accountProfilePermission: "/account/myProfile/primaryAccount",
      accountProfile: "/account/myProfile/primaryAccount",
      viewallotherCasesPermission: "/support/cases/caseList",
      viewFinancialCasesPermission: "/support/cases/caseList",
      supportCases: "/support/cases/caseList",
      myContract: "/account/myContract",
      technicianAppointments: "/account/technicianAppointments",
      viewtechnicianAppointmentsPermission: "/account/technicianAppointments",
    };

    // Handle dynamic routes
    if (permissionName?.includes("/support/cases/viewCaseDetails")) {
      return permissionName;
    }
    if (permissionName?.includes("/account/technicianAppointments/transferDevice")) {
      return "/account/technicianAppointments/transferDevice";
    }
    if (permissionName?.includes("/account/technicianAppointments/removeDevice")) {
      return "/account/technicianAppointments/removeDevice";
    }
    if (
      permissionName?.includes("/account/technicianAppointments/viewAppointmentDetails") ||
      permissionName?.includes("/account/technicianAppointments/reschedule")
    ) {
      return permissionName;
    }

    // Default route
    return routes[permissionName] || "/accessDenied";
  };
  render() {
    const sampleCAMap = {
      "fr-FR": FrenchCASample,
      "de-DE": GermanCASample,
      "nl-NL": DutchCASample,
    };
    const sampleCAImage = sampleCAMap[this.props.userLanguage] || EnglishCASample;

    let pageContent;
    if (this.props.displayPlannedMaintenance) {
      pageContent = (
        <>
          <ManageHeader isSecondLayerPage />
          <PlannedMaintenance />
        </>
      );
    } else if (
      this.checkContractAccountDetails() &&
      // START - RED BALL TOGGLE
      this.hasValidContractAccounts() &&
      // END - RED BALL TOGGLE
      !this.props.account_id
    ) {
      pageContent = (
        <>
          <ManageHeader isSecondLayerPage />
          <SeamlessAcess helpFindCAN={this.helpFindCAN} landOnAuthorizedPage={this.landOnAuthorizedPage} />
        </>
      );
    } else {
      pageContent = <></>;
    }
    return (
      <>
        <Loader active={this.props.isLoading} fullscreen={true} />
        {this.state.connectionError && (
          <StyledGlobalCSS.NotificationBoxMax
            className="notificationErrMsgValidateRevealFailed"
            type="error"
            title={this.props.t("Failed to load. Try again or contact support.", { ns: `${this.state.nameSpace}` })}
            layout="vertical"
            onCloseButtonClick={this.hideError}
          />
        )}

        <RedesignedModal
          ModalAriaLabel="Find Your Contract Account Number"
          opened={this.state.showHelpModal}
          onClickClose={() =>
            this.setState({
              showHelpModal: false,
            })
          }
          title={this.props.t("Find Your Contract Account Number", {
            ns: `${this.state.nameSpace}`,
          })}
          isScrollable={false}
          button={
            <StyledGlobalCSS.CPButton
              size="large"
              boxButton={true}
              secondary={false}
              width="6.875rem"
              buttonWidth={this.props.windowSize.width <= breakPoint && "100%"}
              onClick={() => {
                this.setState({ showHelpModal: false });
              }}
            >
              {this.props.t("OK", { ns: `${this.state.nameSpace}` })}
            </StyledGlobalCSS.CPButton>
          }
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <img
              style={{
                width: "100%",
                height: "100%",
                borderRadius: `${this.props.windowSize.width <= 480 ? "4px" : null}`,
              }}
              src={sampleCAImage}
              alt="Invoice Sample for reference"
            ></img>
          </div>
        </RedesignedModal>

        {pageContent}
      </>
    );
  }
}
const mapStateToProp = (state) => {
  return {
    accountNumber: state.ACCOUNT.accountNumber,
    isLoading: state.ACCOUNT.isLoading,
    userId: state.ACCOUNT.userId,
    userLanguage: state.ACCOUNT.userLanguage,
    timersRunning: state.ACCOUNT.timersRunning,
    userType: state.ACCOUNT.userType,
    accountProfilePermission: state.ACCOUNT.accountProfilePermission,
    viewInvoicesPermission: state.ACCOUNT.viewInvoicesPermission,
    managePaymentsPermission: state.ACCOUNT.managePaymentsPermission,
    viewFinancialCasesPermission: state.ACCOUNT.viewFinancialCasesPermission,
    viewallotherCasesPermission: state.ACCOUNT.viewallotherCasesPermission,
    bannerDisplayOnLanding: state.ACCOUNT.bannerDisplayOnLanding,
    displayPlannedMaintenance: state.ACCOUNT.displayPlannedMaintenance,
    windowSize: state.ACCOUNT.windowSize,
    erpBusinessPartner: state.ACCOUNT.erpBusinessPartner,
    account_id: state.ACCOUNT.account_id,
    activeCookie: state.ACCOUNT.activeCookie,
    enableSecondPage: state.ACCOUNT.enableSecondPage,
    contractAccountCountry: state.ACCOUNT.contractAccountCountry,
    regionId: state.ACCOUNT.regionId,
    contractAccountId: state.BILLING.contractId,
    accountFinancialStatus: state.ACCOUNT.accountFinancialStatus,
    paymentStatus: state.ACCOUNT.paymentStatus,
  };
};

SecondLayerAuth.propTypes = {
  userLanguage: PropTypes.string,
  title: PropTypes.string,
  t: PropTypes.func,
  i18n: PropTypes.object,
  setRevealSessionExpired: PropTypes.func,
  setActiveCookie: PropTypes.func,
  timersRunning: PropTypes.bool,
  setTimersRunning: PropTypes.func,
  getAccountAndUser: PropTypes.func,
  enableSecondPage: PropTypes.bool,
  setSecondPage: PropTypes.func,
  userType: PropTypes.string,
  regionId: PropTypes.string,
  getPermission: PropTypes.func,
  accountNumber: PropTypes.string,
  userId: PropTypes.string,
  navigate: PropTypes.func,
  bannerDisplayOnLanding: PropTypes.bool,
  setBannerDisplayOnAll: PropTypes.func,
  getContractNumbersSuccess: PropTypes.func,
  setContractAccount: PropTypes.func,
  setContractAccountCountry: PropTypes.func,
  getContractNumbers: PropTypes.func,
  isLoading: PropTypes.bool,
  erpBusinessPartner: PropTypes.object,
  account_id: PropTypes.string,
  displayPlannedMaintenance: PropTypes.bool,
  windowSize: PropTypes.object,
  getPaymentStatus: PropTypes.func,
  getPaymentStatusSuccess: PropTypes.func,
};

export default withTranslation([
  "accountTranslation",
  "billingTranslation",
  "headerTranslation",
  "navigationTranslation",
  "loginTranslation",
  "casesTranslation",
  "leftNavigationTranslation",
])(
  withRouter(
    connect(mapStateToProp, {
      setLoader: Actions.setLoader,
      getAccountAndUser: Actions.login,
      getAccount_Id: Actions.getAccount_Id,
      getValidateContract: Actions.getValidateContract,
      setRevealSessionExpired: Actions.setRevealSessionExpired,
      setTimersRunning: Actions.setTimersRunning,
      getPermission: Actions.getPermission,
      setActiveCookie: Actions.setActiveCookie,
      setBannerDisplayOnAll: Actions.setBannerDisplayOnAll,
      getBannerMessage: Actions.getBannerMessage,
      getContractNumbers: Actions.getContractNumbers,
      getContractNumbersSuccess: Actions.getContractNumbersSuccess,
      setSecondPage: Actions.setSecondPage,
      setContractAccount: billingActions.setContractAccount,
      setContractAccountCountry: Actions.setContractAccountCountry,
      getPaymentStatus: Actions.getPaymentStatus,
      getPaymentStatusSuccess: Actions.getPaymentStatusSuccess,
    })(SecondLayerAuth)
  )
);
